import React from "react";
import ReactDOM from "react-dom";

import "react-s-alert/dist/s-alert-default.css";
import "react-s-alert/dist/s-alert-css-effects/slide.css";
import "react-month-picker/css/month-picker.css";
import "react-dates/lib/css/_datepicker.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-select/dist/react-select.css";
import "rc-time-picker/assets/index.css";

import "./index.css";

// Containers
import MyApp from "./containers/MyApp";

const rootEl = document.getElementById("root");

ReactDOM.render(<MyApp />, rootEl);

if (module.hot) {
	module.hot.accept("./containers/MyApp", () => {
		const NextApp = require("./containers/MyApp").default;
		ReactDOM.render(<NextApp />, rootEl);
	});
}



// WEBPACK FOOTER //
// ./src/index.js